import React from "react"; // for JSX
import { SelectColumnFilter, getFooterSum } from "../InventoryMovementsDetails.js"; 

const greenColumnHeaderHighlight = "rgba(0,200,0,.6)";
const redColumnHeaderHighlight   = "rgba(200,0,0,.6)";

// currentInventoryTransactions is now a static array, without useMemo
export const currentInventoryTransactions = [
  {
    Header: "Item Id",
    label: "Item Id",
    Footer: "Total :",
    accessor: "item_id",
    value: "item_id",
    width: 90,
  },
  {
    Header: "Item Description || Brand",
    label: "Item Description || Brand",
    accessor: "desc_brand",
    value: "desc_brand",
    width: 180,
  },
  {
    Header: "Category 🔀",
    label: "Category",
    value: "category",
    accessor: "category",
    Filter: SelectColumnFilter,
    filter: (rows, id, filterValue) => {
      // if no category filter, keep all rows
      if (!filterValue) return rows;

      // read the current sub-category filter
      const subCat = sessionStorage.getItem("subCategoryFilter") || "All";

      return rows.filter(row => {
        const catMatch = row.values[id] === filterValue;
        const subMatch =
          subCat === "All" || row.values.sub_category === subCat;
        return catMatch && subMatch;
      });
    },
    width: 160,
  },
  {
    Header: "Sub Cat",
    label: "Sub Cat",
    value: "sub_category",
    accessor: "sub_category",
    Filter: SelectColumnFilter,
    filter: (rows, id, filterValue) => {
      if (!filterValue) return rows;

      // read the current category filter
      const cat = sessionStorage.getItem("categoryFilter") || "All";

      return rows.filter(row => {
        const subMatch = row.values[id] === filterValue;
        const catMatch = cat === "All" || row.values.category === cat;
        return subMatch && catMatch;
      });
    },
    width: 160,
  },


  {
    Header: "Inventory After Shipped",
    label: "Inventory After Shipped",
    Footer: (data) => <>{getFooterSum(data, "inventory_after_shipped")}</>,
    accessor: "inventory_after_shipped",
    value: "inventory_after_shipped",
    Cell: ({ value }) => {
      const number = Number(value);
      return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
    },
    width: 120,
  },
  {
    Header: "Inventory 🔀",
    label: "Inventory",
    Footer: (data) => <>{getFooterSum(data, "resultant_inventory")}</>,
    accessor: "resultant_inventory",
    value: "resultant_inventory",
    disableSortBy: false,
    showSortIndicator: true,
    disableSortRemove: true,
    Cell: ({ value }) => {
      const number = Number(value);
      return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
    },
    width: 120,
  },
    {
    Header: "Last day closing inventory ",
    //Footer: (data) => <>{getFooterSum(data, "last_day_closing_inventory")}</>,
    Footer: (table) => {
      const total = getFooterSum(table, "last_day_closing_inventory");
      return Number(total)?.toLocaleString("en-IN"); // Format total with commas
    },
    label: "Last day closing inventory ",
    accessor: "last_day_closing_inventory",
    value: "last_day_closing_inventory",
    Cell: ({ value }) => {
      const number = Number(value);
      return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
    },
    width: 120,
  },
  {
    Header: "Last day Inventory in KGs 🔀",
    label: "Last day Inventory in KGs",
    //Footer: (data) => <>{getFooterSum(data, "resultant_inventory_weight")}</>,
    Footer: (table) => {
      const total = getFooterSum(table, "resultant_inventory_weight");
      return Number(total)?.toLocaleString("en-IN"); // Format total with commas
    },
    accessor: "resultant_inventory_weight",
    value: "resultant_inventory_weight",
    disableSortBy: false,
    showSortIndicator: true,
    disableSortRemove: true,
    Cell: ({ value }) => {
      const number = Number(value);
      return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
    },
    width: 120,
  },
  {
    Header: "Last day Inventory Value 🔀",
    label: "Last day Inventory Value",
    Footer: (data) => <>{getFooterSum(data, "inventory_value")}</>,
    accessor: "inventory_value",
    value: "inventory_value",
    disableSortBy: false,
    showSortIndicator: true,
    disableSortRemove: true,
    Cell: ({ value }) => {
      const number = Number(value);
      return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
    },
    width: 120,
  },
  {
    Header: "GRN Qty",
    label: "GRN Qty",
    Footer: (data) => <>{getFooterSum(data, "grn_qty")}</>,
    accessor: "grn_qty",
    value: "grn_qty",
    bgColor: greenColumnHeaderHighlight,
  },
  {
    Header: "Depo Inward",
    label: "Depo Inward",
    Footer: (data) => <>{getFooterSum(data, "child_grn")}</>,
    accessor: "child_grn",
    value: "child_grn",
    bgColor: greenColumnHeaderHighlight,
  },

  {
    Header: "Parent Qty Consumed",
    label: "Parent Qty Consumed",
    Footer: (data) => <>{getFooterSum(data, "stock_transfer")}</>,
    accessor: "stock_transfer",
    value: "stock_transfer",
    bgColor: redColumnHeaderHighlight,
  },

 {
       Header: "Parent Production Balance",
       label: "Parent Production Balance",
       // Footer: (data) => {
       //   const total = React.useMemo(
       //     () => getFooterSum(data, "balance_qty_kgs"),
       //     [data.rows] "balance_qty_kgs"
       //   );
 
       //   return <>{total}</>;
       // },
       Footer: table => getFooterSum(table, "balance_qty"),
       accessor:  "balance_qty",
       value:  "balance_qty",
       bgColor: greenColumnHeaderHighlight,
     }, 
  {
    Header: "Child Qty Produced",
    label: "Child Qty Produced",
    Footer: (data) => <>{getFooterSum(data, "converted_stock")}</>,
    accessor: "converted_stock",
    value: "converted_stock",
    bgColor: greenColumnHeaderHighlight,
  },
  {
    Header: "Shipped Qty",
    label: "Shipped Qty",
    Footer: (data) => <>{getFooterSum(data, "shipped_qty")}</>,
    accessor: "shipped_qty",
    value: "shipped_qty",
    bgColor: redColumnHeaderHighlight,
  },
  {
    Header: "Delivered Qty",
    label: "Delivered Qty",
    Footer: (data) => <>{getFooterSum(data, "delivered_qty")}</>,
    accessor: "delivered_qty",
    value: "delivered_qty",
  },
  {
    Header: "Sample Qty",
    label: "Sample Qty",
    Footer: (data) => <>{getFooterSum(data, "sample_qty")}</>,
    accessor: "sample_qty",
    value: "sample_qty",
    bgColor: redColumnHeaderHighlight,
  },
  {
    Header: "Returned Qty",
    label: "Returned Qty",
    Footer: (data) => <>{getFooterSum(data, "returned_qty")}</>,
    accessor: "returned_qty",
    value: "returned_qty",
    bgColor: greenColumnHeaderHighlight,
  },

  {
    Header: "Customer old returns",
    label: "Customer old returns",
    Footer: (data) => <>{getFooterSum(data, "customer_returns")}</>,
    accessor: "customer_returns",
    value: "customer_returns",
    bgColor: greenColumnHeaderHighlight,
  },
  {
    Header: "Shipped to DC",
    label: "Shipped to Bhiwandi",
    Footer: (data) => <>{getFooterSum(data, "shipped_to_parent")}</>,
    accessor: "shipped_to_parent",
    value: "shipped_to_parent",
    bgColor: redColumnHeaderHighlight,
  },
  {
    Header: "Shipped to depo",
    label: "Shipped to depo",
    Footer: (data) => <>{getFooterSum(data, "shipped_to_child")}</>,
    accessor: "shipped_to_child",
    value: "shipped_to_child",
    bgColor: redColumnHeaderHighlight,
  },
  {
    Header: "Return from depo",
    label: "Return from depo",
    Footer: (data) => <>{getFooterSum(data, "return_from_child")}</>,
    accessor: "return_from_child",
    value: "return_from_child",
    bgColor: greenColumnHeaderHighlight,
  },

  {
    Header: "Dumped Qty",
    label: "Dumped Qty",
    Footer: (data) => <>{getFooterSum(data, "dumped_qty")}</>,
    accessor: "dumped_qty",
    value: "dumped_qty",
    bgColor: redColumnHeaderHighlight,
  },
  {
    Header: "Stock correction",
    label: "Stock correction",
    Footer: (data) => <>{getFooterSum(data, "stock_correction")}</>,
    accessor: "stock_correction",
    value: "stock_correction",
  },
  {
    Header: "Stock discrepancy",
    label: "Stock discrepancy",
    Footer: (data) => <>{getFooterSum(data, "stock_discrepancy")}</>,
    accessor: "stock_discrepancy",
    value: "stock_discrepancy",
  },
  {
    Header: "Stock movement",
    label: "Stock movement",
    Footer: (data) => <>{getFooterSum(data, "stock_movement")}</>,
    accessor: "stock_movement",
    value: "stock_movement",
    bgColor: redColumnHeaderHighlight,
  },
  {
    Header: "Intransit transfer",
    label: "Intransit transfer",
    Footer: (data) => <>{getFooterSum(data, "intransit_transfer")}</>,
    accessor: "intransit_transfer",
    value: "intransit_transfer",
  },
  {
    Header: "Intransit return",
    label: "Intransit return",
    Footer: (data) => <>{getFooterSum(data, "intransit_return")}</>,
    accessor: "intransit_return",
    value: "intransit_return",
  },
  {
    Header: "Parent in Production",
    label: "Parent in Production",
    Footer: (data) => <>{getFooterSum(data, "parent_in_production")}</>,
    accessor: "parent_in_production",
    value: "parent_in_production",
  },
  {
    Header: "Child in Production",
    label: "Child in Production",
    Footer: (data) => <>{getFooterSum(data, "child_in_production")}</>,
    accessor: "child_in_production",
    value: "child_in_production",
  },
  {
    Header: "isActive",
    label: "isActive",
    id: "isActive",
    accessor: "active_status",
    value: "active_status",
    Filter: SelectColumnFilter,
    filter: (rows,id,filterValue) => {
      if (!filterValue || filterValue === "All") return rows;
      return rows.filter(r => r.values[id] === filterValue);
    }
  }
];
